<div class="btn-group vm-btn-dropdown">
  <div class="{{position}}" [ngClass]="splitButton?'btn-group':'dropdown'">
    <ng-container *ngTemplateOutlet="position=='dropleft' ? dropleftTemp : commonTemp"></ng-container>
    <ng-template #dropleftTemp>
      <button class="{{buttonStaticCssclass}} dropdown-toggle custom-dropdown-toggle {{buttonBindingCssclass}}"
              [ngClass]="splitButton ? 'dropdown-toggle-split' : ''"
              [ngStyle]="{'width':splitButton ? '':width,'height':splitButton ? '':height}" [style]="buttonStyle"
              type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
              [disabled]="disabled">
        <span *ngIf="!splitButton">{{text}}</span>
      </button>
      <button type="button" *ngIf="splitButton" class="{{buttonStaticCssclass}} {{buttonBindingCssclass}}"
              (click)="buttonClick($event)" [ngStyle]="{'width': width, 'height': height}" [disabled]="disabled">
        {{text}}
      </button>
    </ng-template>
    <ng-template #commonTemp>
      <button type="button" *ngIf="splitButton" class="{{buttonStaticCssclass}} {{buttonBindingCssclass}}"
              (click)="buttonClick($event)" [ngStyle]="{'width': width, 'height': height}" [disabled]="disabled">
        {{text}}
      </button>
      <button class="{{buttonStaticCssclass}} dropdown-toggle custom-dropdown-toggle {{buttonBindingCssclass}}"
              [ngClass]="splitButton ? 'dropdown-toggle-split' : ''"
              [ngStyle]="{'width':splitButton ? '':width,'height':splitButton ? '':height}" [style]="buttonStyle"
              type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
              [disabled]="disabled">
        <span *ngIf="!splitButton">{{text}}</span>
      </button>
    </ng-template>
    <div class="dropdown-menu dropdown-menu-arrow dropdown-menu-panel {{optionsStaticCssclass}} {{optionsBindingCssclass}}"
         [style]="optionsStyle">
      <ng-container *ngIf="iscomplex; then complex_data; else non_complex_data">
      </ng-container>
      <ng-template #non_complex_data>
        <a [ngClass]="{'active' : item == selectedvalue}" *ngFor="let item of data" (click)="dropdownitemClick(item)"
           class="dropdown-item">
          {{ item }}
        </a>
      </ng-template>
      <ng-template #complex_data>
        <a [ngClass]="{'active' : item[valuefield] == selectedvalue}" *ngFor="let item of data"
           (click)="dropdownitemClick(item)" class="dropdown-item">
          <ng-container *ngIf="item[valuefield]">
            <span *ngIf="fileType=='Image'" class="vm-dropDownicons">
              <img src="{{item[valuefield]}}" height="auto" width="16px" alt="image" class="dropdown-item__img" />
            </span>
          </ng-container>
          <ng-container *ngIf="item[valuefield]">
            <span *ngIf="fileType=='Icon'" class="material-symbols-outlined vm-icon">{{item[valuefield]}}</span>
          </ng-container>
          {{ item[textfield] }}
        </a>
      </ng-template>
    </div>
  </div>
</div>
